import { render } from "./reference.vue?vue&type=template&id=6e73cbb1&scoped=true"
import script from "./reference.vue?vue&type=script&lang=js"
export * from "./reference.vue?vue&type=script&lang=js"

import "./reference.vue?vue&type=style&index=0&id=6e73cbb1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e73cbb1"]])

export default __exports__